export default __webpack_public_path__ + "images/ajax-loader.gif?f1da3573a41d38a07ef46f403a769058";